"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(e){if(Array.isArray(e))return e};
